import { Injectable } from "@angular/core";
import { Http, RequestOptions, ResponseContentType,Headers, RequestMethod } from "@angular/http";
import { Observable } from "rxjs";
import { Response } from '@angular/http';
import { ApiUrlConstants } from "../../common/constants/api.constants";
import { AchService } from "./ach.service";
import { MemberRetailSubscriptionDetail } from "../interface/member-retail-subscription-detail";
import { catchError, map } from "rxjs/operators";
import { ResponseRetailSubscriptionHistory } from "../interface/retail-subscription-history.interface";
import { environment } from "../../../environments/environment";
import { MemberRetailProgramSubscriptionModel } from "../interface/member-retail-program-subscription-model";

@Injectable()
export class RetailSubscriptionService {

  constructor(private _http: Http, private _achService: AchService) { }


  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }

  getRetailSubscriptionPlan(planId: number): Observable<any> {
    const headers = this._achService.getPaymentHeaders();
    return this._http.
      get(ApiUrlConstants.paymentApiUrl + 'chargebee/retail-subscription-plan/' + planId, { headers: headers })
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  getChargeBeeLanguages(): Observable<any> {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/language')
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  getRetailSubscriptionBasedOnId(id: number) {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/' + id)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }
  getRetailSubscriptionsById(id: number): Observable<any> {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/subscriptions/' + id)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  createRetailSubscription(retailSubscription: MemberRetailSubscriptionDetail): Observable<any[]> {
    const body = JSON.stringify(retailSubscription);

    return this._http.post(ApiUrlConstants.manageAccountApiGwUrl + 'retail-subscription', body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  updateRetailSubscription(updateRetailSubscription: MemberRetailProgramSubscriptionModel): Observable<any[]> {
    const body = JSON.stringify(updateRetailSubscription);
    return this._http.put(ApiUrlConstants.manageAccountApiGwUrl + 'retail-subscription/' + updateRetailSubscription.id, updateRetailSubscription)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }


  cancelRetailSubscription(distributorId: string, updateBy: number) {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/cancel/' + distributorId + '?updatedBy=' + updateBy)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }


  cancelRenewalRetailSubscription(distributorId: string, updateBy: number) {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/cancel-renewal/' + distributorId + '?updatedBy=' + updateBy)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  sendPaymentChangeLinkEmail(distributorId: string) {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/email/payment-change-link/' + distributorId)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  resendTermsAndConditionsEmail(distributorId: string) {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/email/resend-termsandcondition/' + distributorId)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  resendSignupEmail(distributorId: string) {
    return this._http.
      get(ApiUrlConstants.accountApiUrl + 'retail-subscription/email/resend-signup/' + distributorId)
      .map((res: any) => res.json())
      .catch(this.handleErrorObservable);
  }

  createChargeBeeSession(customerId) {
    const body = JSON.stringify(customerId);
    const url = ApiUrlConstants.manageAccountApiGwUrl+'retail-subscription/portal-session/customer/' + customerId
    return this._http.post(url, body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  getRetailSubscriptionHistory(retailSubscriptionId:number): Observable<ResponseRetailSubscriptionHistory> {
    const url = ApiUrlConstants.accountApiUrl + 'retail-subscription/subscriptionHistory/' + retailSubscriptionId;
    return this._http.get(url).pipe(map((res) => res.json()), catchError(this.handleErrorObservable));
  }

  updateTermsandCondition(distributorId: string): Observable<any> {
    const body: any = {};
    const url = ApiUrlConstants.manageAccountApiGwUrl + 'retail-subscription/' + distributorId + '/termsAndConditions';
    const headers = new Headers();
    headers.append('guestToken', 'true');
    headers.append('termsAndCondition', 'true');
    const options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
    return this._http
      .post(url,body,options)
      .pipe(map((res:Response)=>res.json()),
      catchError(this.handleErrorObservable))
  }
  
  getTermAndConditonPdf(language:string) {
    const url = environment.cdnURL + '/portals/customercare/chargebee/terms-conditions/Subscription_TermsAndConditions_'+language+'.pdf';
    const headers = new Headers()
    headers.append('Accept', 'application/pdf');
    headers.append('termsAndCondition', 'true');
    const options = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers
    });
    return this._http
      .get(url, options)
      .pipe(map(res => res),
        catchError(this.handleErrorObservable))
  }

  getGuestToken(){
    const url = environment.portalUrl + '/api/guest-token';
    const headers = new Headers();
    headers.append('termsAndCondition', 'true');
    const options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    return this._http
      .get(url,options)
      .pipe(map((res:Response)=>res.json()),
      catchError(this.handleErrorObservable)) 
  }

  checkingTermsAndConditionAccepted(distributorId:string){
    const url = ApiUrlConstants.accountApiUrl + 'retail-subscription/' + distributorId + '/termsAndConditionAccepted';
    const headers = new Headers();
    headers.append('guestToken', 'true');
    headers.append('termsAndCondition', 'true');
    const options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    return this._http
      .get(url,options)
      .pipe(map((res:Response)=>res.json()),
      catchError(this.handleErrorObservable)) 
  }

  getAccountStatus(fboId: any): Observable<any> {
    const url = ApiUrlConstants.customerServiceApiUrl + 'account-status/?distributorID=' + fboId;
    return this._http.get(url).pipe(map((res) => res.json()), catchError(this.handleErrorObservable));
  }

  accountRestriction(accountRestrictionData): Observable<any[]> {
    const body = JSON.stringify(accountRestrictionData);
    return this._http.post(ApiUrlConstants.customerServiceApiUrl + 'account-restriction', body)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

}





// WEBPACK FOOTER //
// ./src/app/customerservice/services/retail-subscription.service.ts